import axios, { getData } from "lib/axios"


export const getAllApprovalRoute = async () => {
    return axios.get(`/approval-route`).then(getData)
}

export const getApprovalRouteByStatus = async (status) => {
    const query = status ? `?status=${status}` : ''
    return axios.get(`/approval-route${query}`).then(getData)
}

export const postApprovalRoute = async (data) => {
    return axios.post(`/approval-route`, data).then(getData)
}

export const putApprovalRoute = async (id, data) => {
    return axios.put(`/approval-route/${id}`, data).then(getData)
}

export const deleteApprovalRoute = async (id) => {
    return axios.delete(`/approval-route/${id}`).then(getData)
}

export const restoreApprovalRoute = async (id) => {
    return axios.post(`/approval-route/${id}/restore`).then(getData)
}
